// extracted by mini-css-extract-plugin
export default {"globalFonts":"fonts_globalFonts__wQoCI","femaleBars":"fonts_femaleBars__k+hM4","maleBars":"fonts_maleBars__GG4UP"};